var participantService = function() {
    var data = {
        maritalStatus: null,
        confirmationNumber: null
    };

    return {
        setMaritalStatus: function(maritalStatus) {
            data.maritalStatus = maritalStatus;
        },
        getMaritalStatus: function() {
            return data.maritalStatus;
        },
        setConfirmationNumber: function(confirmationNumber) {
            data.confirmationNumber = confirmationNumber;
        },
        getConfirmationNumber: function() {
            return data.confirmationNumber;
        },
        reset: function() {
            data.maritalStatus = null;
            data.confirmationNumber = null;
        }
    };
};

export default participantService;